<div class="event-tools-hub">
  <div class="unified-tool-header" *ngIf="showEventList">
    <div class="header-content">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" class="tool-icon">
          <path
            d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V15H17V17M17,13H7V11H17V13M17,9H7V7H17V9Z"
          />
        </svg>
      </div>
      <div class="header-text">
        <h1>Event Tools</h1>
        <p>Pick an event, then open Badge, Group Forms, or Settings</p>
      </div>
    </div>
  </div>

  <div class="tool-content" *ngIf="showEventList">
    <div class="search-section">
      <div class="search-container">
        <svg viewBox="0 0 24 24" class="search-icon">
          <path
            d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
          />
        </svg>
        <input type="text" placeholder="Search events..." [value]="searchTerm" (input)="onSearchTermChanged($event)" class="search-input" />
        <div class="search-actions" *ngIf="searchTerm?.trim()">
          <button class="clear-btn" type="button" (click)="clearSearch()" title="Clear search">
            <svg viewBox="0 0 24 24">
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="(isLoadingEvents && !events.length) || isPreparingTool" class="loading-section">
      <div class="loading-spinner"></div>
      <p>{{ isPreparingTool ? 'Opening tool...' : 'Loading events...' }}</p>
    </div>

    <div *ngIf="eventsErrorMessage && !isLoadingEvents && !isPreparingTool" class="error-section">
      <h3>{{ hasWorkspaceError ? 'Workspace Error' : 'Could not load events' }}</h3>
      <p>{{ eventsErrorMessage }}</p>
    </div>

    <div
      *ngIf="!isPreparingTool && !eventsErrorMessage && (events.length || !isLoadingEvents)"
      class="events-scroll"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="150"
      [immediateCheck]="true"
      [infiniteScrollDisabled]="isLoadingEvents || isLoadingMore || !hasMoreEvents"
      (scrolled)="loadMore()"
    >
      <div class="events-grid" *ngIf="events.length">
        <ngx-admin-event-card
          *ngFor="let event of events"
          [event]="$any(event)"
          [context]="'event-tools'"
          (openBadge)="openBadge($event)"
          (openGroupForms)="openGroupForms($event)"
          (openSettings)="openSettings($event)"
        >
        </ngx-admin-event-card>
      </div>

      <div *ngIf="isLoadingMore" class="loading-more">
        <div class="loading-spinner"></div>
      </div>

      <div *ngIf="!isLoadingEvents && !isLoadingMore && !events.length && !hasMoreEvents" class="empty-state">
        <h3>No Events Available</h3>
        <p>There are no upcoming or live events with forms in this workspace.</p>
      </div>
    </div>
  </div>

  <div class="embedded-tool" *ngIf="activeTool === 'badge' && selectedEvent">
    <ngx-badge-editor [embedded]="true" [initialEvent]="selectedEvent" (exit)="backToEventList()"></ngx-badge-editor>
  </div>

  <div class="embedded-tool" *ngIf="activeTool === 'group-forms' && selectedEvent">
    <ngx-group-forms [embedded]="true" [initialEvent]="$any(selectedEvent)" (exit)="backToEventList()"></ngx-group-forms>
  </div>

  <div class="embedded-tool" *ngIf="activeTool === 'settings' && selectedEvent">
    <ngx-admin-options [initialEvent]="selectedEvent" (exit)="backToEventList()"></ngx-admin-options>
  </div>
</div>
